import React, { Component } from 'react';

import $ from 'jquery';

class TermsModal extends Component {
  
  constructor(props) {
    super(props);
    
    this.state = {
      titulo: "",
      texto: ""
    };
    
    this.keyDown = this.keyDown.bind(this);
    this.close = this.close.bind(this);
  }
  
  componentDidMount() {
    document.addEventListener("keydown", this.keyDown, false);
    this.findTerms();
  }

  componentDidUpdate(prevProps, prevState) {
    const currFreeUser = !this.props.userData || this.props.userData.freeUser;
    const prevFreeUser = !prevProps.userData || prevProps.userData.freeUser;
    if (currFreeUser !== prevFreeUser) {
      this.findTerms();
    }
  }

  findTerms() {
    let me = this;
    fetch(me.props.urlGlobal + "api/page", {
      method: "POST",
      body: JSON.stringify({
        action: "getPage",
        page: "terminosycondiciones",
        lan: me.props.getLanActual()
      }),
      headers: me.props.getHeadersToSend()
    }).then(function(response) {
      return response.json();
    }).then(function(result) {
      if (result.success) {
        me.setState({
          titulo: result.page.titulo,
          texto: result.page.texto
        });
      }
    });
  }
  
  componentWillUnmount() {
    document.removeEventListener("keydown", this.keyDown, false);
  }
  
  keyDown(e) {
    if (e.keyCode === 27) {
      e.preventDefault();
      this.close();
    }
  }
  
  close() {
    $("#terms_modal").fadeOut("fast", function() {
      $("#terms_modal_overlay").fadeOut("fast", function() {
        document.body.style.overflow = "auto";
      });
    });
  }
  
  render() {
    return (
      <div className="modalx-overlay close_mw"
           id="terms_modal_overlay">
        <div className='modal_window' 
             id="terms_modal">
          <button id="close_modal"
                  className="link-button close_mw"
                  onClick={this.close.bind(this)}></button>
          <div className='modal_top'>
            <div className='modal_bottom'>
              <div className='modal_content'>
                {
                  this.state.titulo ? (
                    <h5>
                      {this.state.titulo}
                    </h5>
                  ) : null
                }
                <div className='modal_form'>
                  <div className='terms_text'>
                    <div className='terms_scroll'>
                      {
                        this.state.texto ? (
                          <div dangerouslySetInnerHTML={{__html: this.state.texto}}></div>
                        ) : null
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  
}

export default TermsModal;